import { Vue, Component } from 'vue-property-decorator'
import StatisticalAnalysisHeader from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-header/statistical-analysis-header.vue'
import {
    initialStatisticalAnalysisDossierDelaysAndResponseTimeModelState,
    StatisticalAnalysisDelaysAndResponseTimesDossierSearchInfo,
    StatisticalAnalysisDossierDelaysAndResponseTimeState,
    StatisticsAnalysisDelaysAndResponseTimesTrackingItems
} from '@/modules/statistical-analysis-module/views/delays-and-response-time-dossier/delays-and-response-time-dossier.model'
import StatisticalAnalysisSidebar from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar/statistical-analysis-sidebar.vue'
import { delayAndResponseTimesDossierService } from '@/modules/statistical-analysis-module/services/delay-and-response-times-dossier/delay-and-response-times-dossier.service'
import StatisticalAnalysisDelaysAndResponseTimeGeneral from '@/modules/statistical-analysis-module/components/statistical-analysis-delays-and-response-time-general/statistical-analysis-delays-and-response-time-general.vue'
import { StatisticalAnalysisDelayAndResponseTimesDossierResponseHeaders, StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersCase, StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersCaseTypeCount, StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersPortion, StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersPortionTypeCount, StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersSample, StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersSampleTypeCount, StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersSubportion, StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersSubportionTypeCount } from '@/modules/statistical-analysis-module/services/delay-and-response-times-dossier/delay-and-response-times-dossier.dto'
import { StatisticalAnalysisHeaderNavigationItems } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-header/statistical-analysis-header.models'
import { concat, isNil } from 'lodash'
import { StatisticalAnalysisDelaysAndResponseTimeGeneralSelectionDetail } from '@/modules/statistical-analysis-module/components/statistical-analysis-delays-and-response-time-general/statistical-analysis-delays-and-response-time-general.model'
import StatisticalAnalysisDelaysAndResponseTimeDetail from '@/modules/statistical-analysis-module/components/statistical-analysis-delays-and-response-time-detail/statistical-analysis-delays-and-response-time-detail.vue'
import { StatiscalAnalysisTypeCases, StatisticalAnalysisDelayAndResponseEnum, StatisticalAnalysisDelaysAndResponseTimeGeneralResponseTimeModeSelectorEnum, StatisticalAnalysisEnumsAndKeys } from '@/modules/statistical-analysis-module/shared/models/shared.model'
import { Nullable } from '@/shared/types/app.types'
import StatisticalAnalysisSkeletonDelaysAndResponseTimesDossierBase from '@/modules/statistical-analysis-module/components/statistical-analysis-skeletons/statistical-analysis-skeleton-delays-and-response-times-dossier/statistical-analysis-skeleton-delays-and-response-times-dossier-base/statistical-analysis-skeleton-delays-and-response-times-dossier-base.vue'
import { getIconHeaders } from '@/modules/statistical-analysis-module/shared/helpers/helpers'
@Component({
    components: {
        StatisticalAnalysisSidebar,
        StatisticalAnalysisHeader,
        StatisticalAnalysisDelaysAndResponseTimeGeneral,
        StatisticalAnalysisDelaysAndResponseTimeDetail,
        StatisticalAnalysisSkeletonDelaysAndResponseTimesDossierBase
    }
})
export default class DelaysAndResponseTimeDossier extends Vue {
    state: StatisticalAnalysisDossierDelaysAndResponseTimeState
    constructor() {
        super()
        this.state = initialStatisticalAnalysisDossierDelaysAndResponseTimeModelState()
    }

    get isInitDossier(): boolean {
        return !isNil(this.state.promiseNavigationItems)
    }

    get contentVisible(): boolean {
        return this.state.headerData.navigationItems.length > 0
    }

    get caseSelected(): string {
        return this.state.externalInfo.trackingGeneralSelected?.label!
    }

    get typeSelected(): string {
        return this.state.externalInfo.typeDelaysAndResponseTimes?.text as string
    }

    get isGeneralItemSelected(): boolean {
        return !!this.state.externalInfo.trackingGeneralSelected
    }

    showSpecificView(item: StatisticsAnalysisDelaysAndResponseTimesTrackingItems): void {
        this.state = {
            ...this.state,
            generalView: false,
            externalInfo: {
                ...this.state.externalInfo,
                trackingDetailSelected: item
            }
        }
    }

    backToGlobalView() {
        this.state.generalView = true
    }

    onShowItemSelected(item: StatisticalAnalysisHeaderNavigationItems<number>): void {
        this.state = {
            ...this.state,
            externalInfo: {
                ...this.state.externalInfo,
                trackingGeneralSelected: item
            },
            generalView: true
        }
    }

    onSearch(search: StatisticalAnalysisDelaysAndResponseTimesDossierSearchInfo): void {
        this.state = {
            ...this.state,
            externalInfo: {
                ...this.state.externalInfo,
                startDate: search.startDate,
                endDate: search.endDate,
                laboratories: search.laboratories,
                typeSearch: search.typeSearch,
                typeDelaysAndResponseTimes: search.typeDelaysAndResponseTimes,
                trackingGeneralSelected: null,
                trackingItems: [],
                onlyValidatedCases: search.onlyValidatedCases
            },
            generalView: true,
            headerData: {
                ...this.state.headerData,
                header: {
                    ...this.state.headerData.header,
                    startDate: search.startDate as Date,
                    endDate: search.endDate as Date,
                    elementType: this._getHeaderTitle(search)
                },
                styles: {
                    ...this.state.headerData.styles,
                    icon: getIconHeaders(search.typeSearch?.id as StatiscalAnalysisTypeCases)
                },
                navigationItems: []
            }
        }
        this.state.promiseNavigationItems = this._getInfoGeneralView()
    }

    onSelectedResponseTime(selection: StatisticalAnalysisDelaysAndResponseTimeGeneralSelectionDetail): void {
        this.state = {
            ...this.state,
            externalInfo: {
                ...this.state.externalInfo,
                trackingItems: selection.trackingItems,
                trackingDetailSelected: {
                    key: selection.itemSelected.key as StatisticalAnalysisDelayAndResponseEnum,
                    label: selection.itemSelected.label,
                    value: selection.itemSelected.value
                },
                typeDelay: selection.delayType.id as StatisticalAnalysisDelaysAndResponseTimeGeneralResponseTimeModeSelectorEnum,
                timeFilter: selection.timeFilter
            },
            generalView: false
        }
    }

    onBackView(): void {
        this.state.generalView = true
    }

    onChangeTrackItem(value: StatisticalAnalysisDelaysAndResponseTimeGeneralSelectionDetail): void {
        this.state.externalInfo.trackingDetailSelected = {
            label: value.itemSelected.label,
            key: value.itemSelected.key as StatisticalAnalysisDelayAndResponseEnum
        }
        this.state.externalInfo.trackingItems = value.trackingItems
    }

    onTypeDelay(value: Nullable<StatisticalAnalysisDelaysAndResponseTimeGeneralResponseTimeModeSelectorEnum>): void {
        this.state.externalInfo.typeDelay = value
    }

    private async _getInfoGeneralView(): Promise<void> {
        const response: StatisticalAnalysisDelayAndResponseTimesDossierResponseHeaders = await this.$_toCallSecure<StatisticalAnalysisDelayAndResponseTimesDossierResponseHeaders>(delayAndResponseTimesDossierService.getGeneralViewHeaders(
            this.state.externalInfo.typeSearch?.id as StatiscalAnalysisTypeCases,
            delayAndResponseTimesDossierService.getBaseRequest(this.state.externalInfo)
        )) as StatisticalAnalysisDelayAndResponseTimesDossierResponseHeaders
        this.state.headerData.navigationItems = this._transformNavigationItems(response)
        this.state.headerData.header.total = response.total
    }

    private _transformNavigationItems(data: StatisticalAnalysisDelayAndResponseTimesDossierResponseHeaders): StatisticalAnalysisHeaderNavigationItems<number>[] {
        const totalHeader: StatisticalAnalysisHeaderNavigationItems<number> = {
            key: null,
            icon: 'far fa-list-ul',
            label: this.$tc('statisticalAnalysis.dossiers.delaysAndResponseTimes.caseTypes.all'),
            value: data.total
        }
        let otherCasesTypes!: StatisticalAnalysisHeaderNavigationItems<number> []
        switch (this.state.externalInfo.typeSearch?.id) {
        case StatiscalAnalysisTypeCases.CASE:
            otherCasesTypes = (data as StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersCase).caseTypeCount?.map((item: StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersCaseTypeCount) => {
                return {
                    key: item.caseType.id,
                    icon: getIconHeaders(StatiscalAnalysisTypeCases.CASE),
                    label: item.caseType.description,
                    value: item.total
                }
            })
            break
        case StatiscalAnalysisTypeCases.SAMPLE:
            otherCasesTypes = (data as StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersSample).sampleTypeCount?.map((item: StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersSampleTypeCount) => {
                return {
                    key: item.sampleType.id,
                    icon: getIconHeaders(StatiscalAnalysisTypeCases.SAMPLE),
                    label: item.sampleType.description,
                    value: item.total
                }
            })
            break
        case StatiscalAnalysisTypeCases.PORTION:
            otherCasesTypes = (data as StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersPortion).portionTypeCount?.map((item: StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersPortionTypeCount) => {
                return {
                    key: item.portionType.potId,
                    icon: getIconHeaders(StatiscalAnalysisTypeCases.PORTION),
                    label: item.portionType.potName,
                    value: item.total
                }
            })
            break
        case StatiscalAnalysisTypeCases.SUBPORTION:
            otherCasesTypes = (data as StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersSubportion).subportionTypeCount?.map((item: StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersSubportionTypeCount) => {
                return {
                    key: item.subportionType.sptId,
                    icon: getIconHeaders(StatiscalAnalysisTypeCases.SUBPORTION),
                    label: item.subportionType.sptName,
                    value: item.total
                }
            })
            break
        default:
            otherCasesTypes = []
        }

        return concat([], totalHeader, otherCasesTypes)
    }

    private _getHeaderTitle(search: StatisticalAnalysisDelaysAndResponseTimesDossierSearchInfo): string {
        switch (search.typeSearch?.id) {
        case StatisticalAnalysisEnumsAndKeys.CASE.getId():
            return search?.onlyValidatedCases ? 'statisticalAnalysis.dossiers.delaysAndResponseTimes.typeView.validatedCases' : 'statisticalAnalysis.dossiers.delaysAndResponseTimes.typeView.registeredCases'
        case StatisticalAnalysisEnumsAndKeys.SAMPLE.getId():
            return search?.onlyValidatedCases ? 'statisticalAnalysis.dossiers.delaysAndResponseTimes.typeView.validatedSamples' : 'statisticalAnalysis.dossiers.delaysAndResponseTimes.typeView.registeredSamples'
        case StatisticalAnalysisEnumsAndKeys.PORTION.getId():
            return search?.onlyValidatedCases ? 'statisticalAnalysis.dossiers.delaysAndResponseTimes.typeView.validatedPortions' : 'statisticalAnalysis.dossiers.delaysAndResponseTimes.typeView.registeredPortions'
        case StatisticalAnalysisEnumsAndKeys.SUBPORTION.getId():
            return search?.onlyValidatedCases ? 'statisticalAnalysis.dossiers.delaysAndResponseTimes.typeView.validatedSubportions' : 'statisticalAnalysis.dossiers.delaysAndResponseTimes.typeView.registeredSubportions'
        default:
            return ''
        }
    }
}
